// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { StaySummaryMenuComponent } from './stay-summary-menu.component';
import { SectorModule } from 'libraries/service/sector/sector.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    declarations: [
        StaySummaryMenuComponent,
    ],
    imports: [
        CommonModule,
        SectorModule,
        FontAwesomeModule,
    ],
    exports: [
        StaySummaryMenuComponent,
    ],
    providers: [],
})
export class StaySummaryMenuModule {}